import * as React from 'react';
export const hongleongSvg = React.forwardRef(function hongleongSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm7 9.559 1.865-1.405c.824 2.149 3.362 5.43 6.355 7.69 3.335 2.538 7.152 3.541 8.731 3.452l.094-.007v2.865c-2.733.11-8.87-2.232-12.578-6.31-1.614-1.816-3.249-3.682-4.318-5.958L7 9.56Zm3.275-2.564 1.908-1.404c2.518 4.99 7.116 8.406 11.643 8.776l.22.016v2.81c-5.45-.325-10.753-4.614-13.645-9.961l-.126-.237ZM15.457 3c2.213 4.107 6.182 6.34 8.588 6.42v2.896c-3.75-.551-7.395-2.646-10.518-7.827L15.457 3Z',
      fill: '#00529B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.045 19.26v2.868c-1.452.081-3.426.909-5.27 2.397-1.162.96-2.288 2.188-3.157 3.708l-.16.288-1.93-1.46c1.626-2.702 3.404-4.575 5.248-5.787 1.713-1.13 3.47-1.738 5.27-2.014Zm0-4.877v2.81c-1.778.139-3.578.717-5.27 1.71-2.562 1.467-4.881 3.868-6.443 6.797l-.149.285-1.909-1.35c1.931-3.722 5.01-6.918 8.502-8.736 1.691-.855 3.47-1.406 5.27-1.516Zm-5.27-3.666c2.105-.882 4.035-1.351 5.27-1.267v2.866c-.997-.112-3.014.304-5.27 1.323a20.032 20.032 0 0 0-3.555 2.122c-2.993 2.288-5.531 5.62-6.311 7.772L7 22.128c1.063-2.398 2.777-4.41 4.467-6.34 2.039-2.232 4.793-3.97 7.309-5.072Z',
      fill: '#CE1041',
    }),
  );
});
hongleongSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hongleong = {
  category: 'brand',
  colorable: false,
  name: 'hongleong',
  svg: hongleongSvg,
};
